'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import classNames from 'classnames';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import { EERIE } from 'HubStyleTokens/colors';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import FileResultsList from 'DesignFinderUI/components/results/FileResultsList';
export default class FileResults extends PureComponent {
  renderResults(props) {
    const {
      children
    } = props,
          rest = _objectWithoutPropertiesLoose(props, ["children"]);

    if (children) {
      return children;
    }

    return /*#__PURE__*/_jsx(UIScrollContainer, {
      className: "file-results__scroll-section",
      children: /*#__PURE__*/_jsx(FileResultsList, Object.assign({}, rest))
    });
  }

  render() {
    const _this$props = this.props,
          {
      children,
      className,
      footer,
      headerText,
      isFetching,
      onClose
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "footer", "headerText", "isFetching", "onClose"]);

    const wrapperClasses = classNames('file-results', className, isFetching && 'file-results--fetching');
    const closeButtonStyles = {
      position: 'relative',
      top: 'auto',
      right: 'auto'
    };
    const renderedResults = this.renderResults(Object.assign({
      children,
      isFetching
    }, rest));
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "stretch",
      className: wrapperClasses,
      direction: "column",
      justify: "end",
      children: [/*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(UIMediaObject, {
          align: "center",
          className: "file-results__header-wrapper",
          itemRight: /*#__PURE__*/_jsx(UICloseButton, {
            color: EERIE,
            onClick: onClose,
            size: "small",
            style: closeButtonStyles
          }),
          children: /*#__PURE__*/_jsx("span", {
            className: "file-results__header is--heading-7 m-bottom-0",
            children: headerText
          })
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        grow: 1,
        style: {
          position: 'relative'
        },
        children: renderedResults
      }), /*#__PURE__*/_jsx(UIBox, {
        children: footer
      })]
    });
  }

}
FileResults.displayName = 'FileResults';
FileResults.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  fetchError: PropTypes.instanceOf(Error),
  footer: PropTypes.node,
  headerText: PropTypes.node,
  isFetching: PropTypes.bool,
  onClose: PropTypes.func,
  resultsRenderer: PropTypes.func
};
FileResults.defaultProps = {
  children: null,
  className: '',
  fetchError: null,
  footer: null,
  headerText: '',
  isFetching: null,
  onClose: emptyFunction
};